import React, { Component } from "react"
import Radium, { StyleRoot } from "radium"
import Loader from "../common/loader"
import Pagination from "./../common/pagination"
import { paginate } from "./../../utils/paginate"
import ListGroup from "./../common/listGroup"
import PortfolioTemplate from "./portfolioTemplate"
import { getPorfolioCategory } from "./../../services/portfolioCategoryService"
import { getPortfolios } from "./../../services/portfolioService"
import "./portfolios.css"

class MorosoftPortfolio extends Component {
  constructor(props) {
    super(props)
    this.state = {
      portfolioItems: [],
      portfolioCategories: [],
      selectedPortfolio: "",
      loading: true,
      pageSize: 9,
      currentPage: 1,
    }
  }

  async componentDidMount() {
    const { data: portfolioItems } = await getPortfolios()
    const { data } = await getPorfolioCategory()

    const portfolioCategories = [{ id: "", Name: "All" }, ...data]
    this.setState({ portfolioItems, portfolioCategories, loading: false })

    console.log("Portfolios: ", portfolioItems)
    console.log("portfolio Categories: ", portfolioCategories)
  }

  handlePageChange = page => {
    this.setState({ currentPage: page })
  }

  handleCategorySelect = category => {
    this.setState({ selectedPortfolio: category, currentPage: 1 })
    console.log("Category is:", category)
  }

  render() {
    const {
      portfolioItems,
      pageSize,
      currentPage,
      portfolioCategories,
      selectedPortfolio,
    } = this.state
    // const portfolios = paginate(filtered, currentPage, pageSize)

    const filtered =
      selectedPortfolio && selectedPortfolio.id
        ? portfolioItems.filter(portfolio => {
            const { categories } = portfolio
            let match = categories.some(cat => cat.id === selectedPortfolio.id)
            return match
          })
        : portfolioItems

    if (this.state.loading) return <Loader />

    return (
      <React.Fragment>
        <section id="all-portfolios">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <ListGroup
                  items={portfolioCategories}
                  selectedItem={selectedPortfolio}
                  onItemSelect={this.handleCategorySelect}
                />
              </div>
            </div>
            <div id="portfolios">
              <PortfolioTemplate filtered={filtered} />
            </div>
            {/* <Pagination
              itemsCount={filtered.length}
              currentPage={currentPage}
              pageSize={pageSize}
              onPageChange={this.handlePageChange}
            /> */}
          </div>
        </section>
      </React.Fragment>
    )
  }
}

export default MorosoftPortfolio
